import React from 'react'
import ReactDOM from 'react-dom'
import 'es6-shim'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import green from '@material-ui/core/colors/green'
import grey from '@material-ui/core/colors/grey'
import App from './App.jsx'

document.title = 'ACIS Windroses'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: green[800],
    },
  },
  typography: {
    h1: {
      fontSize: "1.3rem",
      fontWeight: "500",
    },
  },
  overrides: {
    MuiListItem: {
      root: {
        paddingTop: "0.25em",
        paddingBottom: "0.25em",
      },
    },
    MuiTableRow: {
      root: {
        height: "1em",
      },
      head: {
        height: "1.5em",
      },
    },
    MuiTableCell: {
      root: {
        fontSize: "80%",
	      padding: "0 3px",
	      border: "1pt solid " + green[700],
        textAlign: "center",
      },
      head: {
        fontSize: "80%",
        fontWeight: "500",
	      padding: "0 3px",
	      border: "1pt solid " + green[700],
        textAlign: "center",
      },
      footer: {
        fontSize: "80%",
	      padding: "0 3px",
	      border: "1pt solid " + green[700],
	      borderBottom: "1pt solid " + green[700],
        textAlign: "center",
        color: grey[800],
      },
      body: {
        fontSize: "80%",
	      padding: "0 3px",
	      border: "1pt solid " + green[700],
        textAlign: "center",
      },
    },
  },
})

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <App />
  </MuiThemeProvider>,
  document.getElementById('root')
)


// WEBPACK FOOTER //
// ./src/index.js